import React from 'react';
import { VolumeCard } from './VolumeCard';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-canvas" data-id="element-345" data-mp="3utm4aq96wfw5">
      <div className="max-w-6xl mx-auto" data-id="element-346" data-mp="co93d1bhz2i4">
        <div className="text-center mb-16" data-id="element-347" data-mp="cn7t2z2b2k1g">
          <p className="text-gold font-semibold tracking-widest uppercase text-xs mb-3" data-id="element-348" data-mp="7pemw6105q16">
            6-in-1 complete boxing coaching system
          </p>
          <h2 className="text-4xl md:text-5xl font-display font-bold mb-4 text-white" data-id="element-349" data-mp="3g613x43p8urx">
            <span className="text-gold" data-id="element-350" data-mp="3c4ntegpnw3eo">6 complete volumes.</span> One complete coaching system.
          </h2>
          <p className="text-xl text-mist" data-id="element-351" data-mp="3pvsy3x7vzlvv">
            150 ready-to-coach sessions · Beginner to advanced · Nothing to build from scratch
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-352" data-mp="2xe87t0tc2tfz">
          {volumes.map((volume, index) => <VolumeCard key={volume.title} volume={volume} index={index} data-id="element-353" data-mp="2sg6pii3qey5k" data-mpi={index} />)}
        </div>
      </div>
    </section>;
}